// extracted by css-extract-rspack-plugin
export default {"container":"Header-module__container__eSl2D"};